import {CenterHero} from "../../blocks/hero/Hero";
import {Footer} from "../../blocks/footer/Footer";

export default function TicketOverPage(){

    return(
        <>
            <CenterHero
                url={'/benefitshare/img/headerbg3.jpg'}
                megaphone={'Shaping success, sharing great ideas'}
                titles={['Jegyvásárlás']}
                fill={'#f0f2f8'}
            ></CenterHero>
            <section id={'newsletter'}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 last-paragraph-no-margin"
                             data-anime={JSON.stringify({
                                 "el": "childs",
                                 "translateY": [50, 0],
                                 "opacity": [0, 1],
                                 "duration": 1200,
                                 "delay": 0,
                                 "staggervalue": 150,
                                 "easing": "easeOutQuad"
                             })}>
                            <h3 className="alt-font fw-600 text-dark-gray">BeneFit SHARE conference</h3>
                            <h5 style={{lineHeight:'160%'}}>
                                Tisztelt Látogatónk!<br/>
                                Köszönjük az érdeklődést!<br/>A jegyvásárlás lezárult az ezévi eseményünkre!<br/>
                                <span style={{fontSize:'1.1rem'}}>a BeneFit SHARE Csapata</span>
                            </h5>
                        </div>
                    </div>
                </div>
            </section>
            <Footer></Footer>
        </>
    )
}